/* eslint-disable react-hooks/exhaustive-deps */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { InputText } from "primereact/inputtext"
import { InputNumber } from "primereact/inputnumber"
import { sspDisplayTableStyles } from "./styles";

/**
 *
 * @param {Object} props
 * @param {string} props.adapterParameterName 
 * @param {string} props.type
 * @param {"tab" | "mob" | "desk"} props.device 
 * @param {Object} props.values
 * @param {number} props.idx
 * @param {(parameterName: string, device: "tab" | "mob" | "desk", value: string) => void} props.changeHandler
 * @returns {React.JSX} 
 */
const SspInputRow = ({
    type,
    adapterParameterName,
    device,
    idx,
    values,
    changeHandler,
}) => {
    let props = {
        value: values?.[idx]?.[adapterParameterName] || '',
        onChange: ev => {
            let value = type === 'number'
                ? ev.value
                : ev.target.value
            changeHandler(adapterParameterName, device, value)
        }
    }
    let Component = type === 'number' ? InputNumber : InputText
    if (type === 'number') {
        props.useGrouping = false
    }
    return (
        <span className="ssp-input">
            <Component {...props} />
        </span>
    )
}


/**
 * 
 * @param {Object} props 
 * @param {AdapterConfig} props.display
 * @param {string} props.adapterName
 * @param {Object} props.mobValues
 * @param {Object} props.tabValues
 * @param {Object} props.deskValues
 * @param {(parameterName: string, device: "tab" | "mob" | "desk", value: string) => void} props.changeHandler
 * @returns 
 */
const DisplaySspParametersTable = ({
    adapterName,
    display,
    mobValues,
    tabValues,
    deskValues,
    changeHandler = () => { }
}) => {
    return (
        <table css={css`${sspDisplayTableStyles}`}>
            <thead>
                <tr>
                    <th className="empty-row"></th>
                    <th className="low-green">Mobile</th>
                    <th className="low-purple">Tablet</th>
                    <th className="low-yellow">Desktop</th>
                </tr>
            </thead>
            <tbody>
                {
                    display
                        ?.adapterParametersNames
                        .map(([name, type, prettyName], parameterIndex) => {
                            let props = { idx: 0, adapterParameterName: name, changeHandler, adapterName, type }
                            return (
                                <tr key={prettyName || name}>
                                    <td><strong>{prettyName}</strong></td>
                                    <td className="light-green">
                                        <SspInputRow {...props} device="mob" values={mobValues} />
                                    </td>
                                    <td className="pink">
                                        <SspInputRow {...props} device="tab" values={tabValues} />
                                    </td>
                                    <td className="light-yellow">
                                        <SspInputRow {...props} device="desk" values={deskValues} />
                                    </td>
                                </tr>
                            )
                        })
                }
            </tbody>
        </table>
    )
}

export default DisplaySspParametersTable